var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Stackshare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ef00ff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,4c-2.19733,0 -4,1.80267 -4,4v34c0,2.19733 1.80267,4 4,4h36c2.19733,0 4,-1.80267 4,-4v-34c0,-2.19733 -1.80267,-4 -4,-4zM7,6h36c1.11667,0 2,0.88333 2,2v34c0,1.11667 -0.88333,2 -2,2h-36c-1.11667,0 -2,-0.88333 -2,-2v-34c0,-1.11667 0.88333,-2 2,-2zM36,11c-2.40721,0 -4.43156,1.72539 -4.89844,4h-4.10156c-0.36332,-0.00042 -0.69829,0.19622 -0.875,0.51367l-4.71484,8.48633h-2.51172c-0.46688,-2.27461 -2.49123,-4 -4.89844,-4c-2.74958,0 -5,2.25042 -5,5c0,2.74958 2.25042,5 5,5c2.40721,0 4.43156,-1.72539 4.89844,-4h2.51172l4.71484,8.48633c0.17671,0.31745 0.51168,0.5141 0.875,0.51367h4.10156c0.46688,2.27461 2.49123,4 4.89844,4c2.74958,0 5,-2.25042 5,-5c0,-2.74958 -2.25042,-5 -5,-5c-2.40721,0 -4.43156,1.72539 -4.89844,4h-3.51367l-4.44336,-8l4.44336,-8h3.51367c0.46688,2.27461 2.49123,4 4.89844,4c2.74958,0 5,-2.25042 5,-5c0,-2.74958 -2.25042,-5 -5,-5zM36,13c1.6687,0 3,1.3313 3,3c0,1.6687 -1.3313,3 -3,3c-1.6687,0 -3,-1.3313 -3,-3c0,-1.6687 1.3313,-3 3,-3zM14,22c1.6687,0 3,1.3313 3,3c0,1.6687 -1.3313,3 -3,3c-1.6687,0 -3,-1.3313 -3,-3c0,-1.6687 1.3313,-3 3,-3zM36,31c1.6687,0 3,1.3313 3,3c0,1.6687 -1.3313,3 -3,3c-1.6687,0 -3,-1.3313 -3,-3c0,-1.6687 1.3313,-3 3,-3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Stackshare);
export default __webpack_public_path__ + "static/media/icons8-stackshare.073d566bfdb444bc8c3d3928a66b0f74.svg";
export { ForwardRef as ReactComponent };